// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","logoLink":"Footer_logoLink__3ig0-","logo":"Footer_logo__3b2YI","divider":"Footer_divider__Llkj4"};